import { trainerDetailPromise } from 'api/WorkoutTrainer'
import React, { useLayoutEffect, useState } from 'react'
import Form from './form'

export default function (props) {
  const { id } = props.match.params
  const [data, setData] = useState({})

  useLayoutEffect(() => {
    trainerDetailPromise(id).then(resp => setData(resp))
  }, [id])

  return <Form oldId={id} data={data} setData={setData} {...props} />
}
